import axios from "axios";
import { fetchAuthSession, signOut } from "aws-amplify/auth";

const createInstance = () => {
  const instance = axios.create({
    baseURL: "https://api.zodhyatech.com/dev/v2",
  });

  // Before every request, Amplify automatically checks
  // if token is expired and refreshes it — no manual logic needed
  instance.interceptors.request.use(async (config) => {
    try {
      // fetchAuthSession auto-refreshes access/ID token silently
      // using refresh token — user never gets logged out for this
      const session = await fetchAuthSession({ forceRefresh: false });
      const token = session.tokens?.idToken?.toString();
      if (!token) throw new Error("No token");
      config.headers.Authorization = token;
    } catch (e) {
      // Only hits here if refresh token expired (after 30 days)
      // Clear both Amplify state AND localStorage
      try {
        await signOut();
      } catch (_) {}
      localStorage.removeItem("orgID");
      localStorage.removeItem("userData");
      window.location.href = window.location.origin;
    }
    return config;
  });

  // If we still get a 401, force logout cleanly
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem("orgID");
        localStorage.removeItem("userData");
        window.location.href = window.location.origin;
      }

      return Promise.reject(error);
    },
  );

  return instance;
};

export default createInstance;
